import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import Standard from './Standard'

const Money = props => {
  const {
    validations,
    onChange,
    onBlur,
    value: _value,
    required,
    allowDefaultZero,
    ...other
  } = props

  const [value, setValue] = useState()

  useEffect(() => {
    setValue(
      edit(
        !_value || _value === '' || _value === 0
          ? allowDefaultZero
            ? 0
            : ''
          : _value
      )
    )
  }, [_value, allowDefaultZero])

  const handleOnChange = (e, { value }, valid) => {
    const editedValue = edit(value)
    setValue(editedValue)
    onChange(e, { value: editedValue }, isValid(value))
  }

  const handleOnBlur = (e, { value }, valid) => {
    const editedValue = edit(value)
    setValue(editedValue)
    onBlur(e, { value: editedValue }, isValid(value))
  }

  const isValid = val => {
    if (val === '-') return false
    if (required && (val === undefined || val === null || val === ''))
      return false
    if (val === undefined || val === null || val === '') return true
    return val.toString().match(/^[0-9-,]+$/) ? true : false
  }

  const edit = val => {
    if (!isValid(val)) return val
    if (val === undefined || val === null || val === '' || val === '-')
      return val
    return parseInt(val.toString().replace(/,/g, ''))
      .toString()
      .replace(/(\d)(?=(\d{3})+$)/g, '$1,')
  }

  return (
    <Standard
      {...other}
      type='tel'
      alignRight
      validations={_.merge({}, validations, { isMoney: true })}
      required={required}
      value={value}
      onChange={handleOnChange}
      onBlur={handleOnBlur}
    />
  )
}

export default Money

Money.propTypes = {
  validations: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  required: PropTypes.bool,
  allowDefaultZero: PropTypes.bool,
}

Money.defaultProps = {
  validations: {},
  onChange: () => {},
  onBlur: () => {},
  required: false,
  allowDefaultZero: true,
}
